// @flow
import React from "react";
import {Polygon} from "react-google-maps";
import {styles} from "../../../config";
import {connect} from "react-redux";
import MapDataSelectors from "../../../Store/Ducks/MapData/selectors";
import Screens from "../../../Store/Views/screens";

// To show the service polygon, we need to puncture the polygon as a hole in "the entire map" polygon
const entireMapPath = [
    {lat: -90, lng: 180.000},
    {lat: -90, lng: -120.000},
    {lat: -90, lng: -60.000},
    {lat: -90, lng: 0.000},
    {lat: -90, lng: 60.000},
    {lat: -90, lng: 120.000},
    {lat: -90, lng: 180.000},
    {lat: 90, lng: 180.000},
    {lat: 90, lng: 120.000},
    {lat: 90, lng: 60.000},
    {lat: 90, lng: 0.000},
    {lat: 90, lng: -60.000},
    {lat: 90, lng: -120.000},
    {lat: 90, lng: 180.000}
];

const polygonOptionsBase = {
    // paths: [entireMapPath].concat(polygonPaths),
    strokeOpacity: 0,
    strokeWeight: 0,
};

const polygonPathOptions = {
    strokeOpacity: 1.0,
    strokeWeight: 2,
    fillOpacity: 0
};

const ServicePolygon = (props => {
        const strokeColor = props.inZone ? styles.polygon.outlineStrokeColorInZone : styles.polygon.outlineStrokeColorOutOfZone;
        const polygonPaths = props.polygonPaths;
        const visualPolygonPath = [entireMapPath].concat(polygonPaths);
        const color = props.showRequest && !props.inZone ? styles.polygon.outOfZoneColor : styles.polygon.inZoneColor;
        const opacity = props.showRequest && !props.inZone ?
            styles.polygon.outOfZoneOpacity : styles.polygon.inZoneOpacity;
        let polygonOptions = {
            ...polygonOptionsBase,
            fillColor: color,
            fillOpacity: opacity,
        };

        return [
            <Polygon
                key={"Service Polygon"}
                {...props}
                options={polygonOptions}
                paths={visualPolygonPath}
            />,
            <Polygon
                key={"Service Polygon Outline"}
                {...props}
                options={{ ...polygonPathOptions, strokeColor }}
                paths={polygonPaths}
            />
        ];
    }
);
const mapStateToProps = (state, props) => {
    return {
        inZone: MapDataSelectors.isMapCenterInZone(state),
        showRequest: Screens.shouldShowRideRequest(state),
    };
};
export default connect(mapStateToProps)(ServicePolygon);



// WEBPACK FOOTER //
// ./src/Components/Map/ServicePolygon/ServicePolygon.js